<template>
  <a-layout class="full-window">
    <a-layout-content>
      <div class="header-container">
        <div class="slogan-container">
          <div class="brand">
            <div class="brand-line">Crew</div>
            <div class="brand-line">Connect</div>
          </div>
          <div class="moto">
            <div class="moto-line">Forget paperwork. Let's</div>
            <div class="moto-line">do what we do the best.</div>
          </div>
          <div class="subject">Cinema!</div>
        </div>
      </div>
      <div class="main-content">
        <slot></slot>
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script lang="ts" setup>
defineOptions({
  name: 'LoginLayoutMobile',
  displayName: 'LoginLayoutMobile'
})
</script>
<style scoped lang="scss">
.header-wrapper {
  justify-content: center;
  height: 74px;
}
.slogan-container {
  color: var(--color-primary);
  padding-left: 40px;
  padding-top: 25vh;
}
.brand {
  font-size: 64px;
  .brand-line {
    line-height: 64px;
  }
}
.moto {
  padding-top: 10px;
  .moto-line {
    line-height: 16px;
  }
}
.subject {
  font-size: 32px;
}
@mixin container-styles {
  position: relative;
  z-index: 1;
  right: 0px;
  padding-left: 0 !important;
  min-width: 1152px;
  max-width: 1152px;
  display: inline-flex;
  height: 74px;
}

@mixin responsive-container {
  min-width: 100%;
  max-width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

/* Use mixins */
.header-container {
  @include container-styles;
}

@media (max-width: 1152px) {
  .header-container {
    @include responsive-container;
  }
}

@media (max-width: 768px) {
  .header-container {
    @include responsive-container;
    height: auto;
    display: block;
  }
}

.header-container::v-deep(a) {
  font-weight: bold;
}
.header-container::v-deep(a:hover) {
  color: unset;
}
.header-left {
  width: 175px;
}
.header-middle {
  width: 100%;
}
.header-right {
  display: inline-flex;
  position: relative;
  right: 0;
  padding: 20px;
}
.full-window {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

:deep(.ant-layout-content) {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.main-content {
  display: flex;
  justify-content: center;
  align-items: end;
  overflow: scroll;
  width: 100%;
  flex: 1;
}
#footer-content {
  height: 20px;
}
.foot-notes {
  justify-content: center;
  margin-bottom: 10px;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
